/**
 * Hariom ERP - Settings stores (persisted).
 *  - company profile (single editable record, seeded with the real company)
 *  - app users list (CRUD, starts empty — admin adds real users)
 */
import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'
import { createCrudStore } from './createCrudStore'
import { sharedStorage } from './sharedStorage'

export interface CompanyProfile {
  name: string
  license: string
  email: string
  phone: string
  gst: string
  cin: string
  address: string
}

const DEFAULT_COMPANY: CompanyProfile = {
  name: 'Hariom Coatings Private Limited',
  license: 'HE-ERP-2026-001',
  email: 'info@hariomepoxyshield.com',
  phone: '+91 81099-90000',
  gst: '22ABCDE1234F1Z5',
  cin: 'U27100MH2010PTC123456',
  address: 'Village - Gaurapur, Tehsil - Wada, Dist. - Palghar, 421312, Maharashtra, India',
}

interface SettingsState {
  company: CompanyProfile
  setCompany: (c: CompanyProfile) => void
}

export const useSettingsStore = create<SettingsState>()(
  persist(
    (set) => ({
      company: DEFAULT_COMPANY,
      setCompany: (c) => set({ company: c }),
    }),
    { name: 'hariom-erp-company', storage: createJSONStorage(() => sharedStorage) }
  )
)

export interface AppUser {
  id: string
  name: string
  email: string
  role: string
  status: string
}

export const useUsersStore = createCrudStore<AppUser>('hariom-erp-users')
